import api from './api';

export interface SecurityStatus {
  mfaEnabled: boolean;
  mfaLastUsed?: string;
  backupCodesRemaining: number;
  passwordExpiresAt?: string;
  passwordLastChanged: string;
  accountLocked: boolean;
  lockoutUntil?: string;
  failedLoginAttempts: number;
  lastLoginAt?: string;
  lastLoginIP?: string;
}

export interface SecurityEvent {
  id: string;
  eventType: string;
  timestamp: string;
  ipAddress: string;
  userAgent: string;
  description: string;
  success: boolean;
}

export interface ActiveSession {
  id: string;
  device: string;
  ipAddress: string;
  userAgent: string;
  lastActivity: string;
  current: boolean;
}

class SecurityService {
  /**
   * Get current user's security status
   */
  async getSecurityStatus(): Promise<SecurityStatus> {
    const response = await api.get('/auth/security/status');
    return response.data.data;
  }

  /**
   * Get security events for current user
   */
  async getSecurityEvents(): Promise<SecurityEvent[]> {
    const response = await api.get('/auth/security/events');
    return response.data.data;
  }

  /**
   * Get active sessions for current user
   */
  async getActiveSessions(): Promise<ActiveSession[]> {
    const response = await api.get('/auth/security/sessions');
    return response.data.data;
  }
}

const securityService = new SecurityService();
export default securityService;
